import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import HeroPreviewCard from './HeroPreviewCard';
import HeroVisual from './HeroVisual';
import './HeroSection.css';
import { trackEvent } from '../../utils/analytics';

const REVIEWS = [
  { name: '박**', text: '제 뼈대 특징을 정확히 짚어내서 놀랐어요. 정말 용템 추천까지 완벽!', score: 5 },
  { name: '김*석', text: '제가 왜 특정 유형에게만 인기가 많은지 드디어 이해했습니다 ㅋㅋ', score: 5 },
  { name: '이*지', text: '첫인상 테스트 중 제일 고급스럽고 정확해요. 케미스트리 분석 강추!', score: 5 },
  { name: '최*우', text: '내가 몰랐던 내 매력을 숫자로 보니까 자신감이 생기네요.', score: 4.9 },
  { name: '정*아', text: '친구랑 같이 해봤는데 둘 다 소름 돋았어요. 너무 잘 맞아요.', score: 5 },
];

export default function HeroSection() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const handleStyleCheckClick = () => {
    trackEvent('feature_selected', {
      feature_name: 'style_check',
      feature_type: 'style_check',
      source_page: 'home_hero',
    });
    navigate('/style-beta');
  };
  const handleFaceAnalysisClick = () => {
    trackEvent('feature_selected', { feature_name: 'face_analysis', feature_type: 'face', source_page: 'home_hero_secondary' });
    navigate('/info');
  };

  return (
    <section className="hero-section">
      <div className="hero-container">
        <div className="hero-text-content">
          <h1 className="hero-headline">{t('home.hero.headline')}</h1>
          <p className="hero-subtext">{t('home.hero.subtext')}</p>

          <div className="hero-cta-area" style={{ marginTop: '0.5rem' }}>
            <button
              className="hero-cta-button"
              onClick={handleStyleCheckClick}
            >
              {t('home.hero.cta_button')}
            </button>
            <p
              className="hero-micro-hint"
              style={{
                fontSize: '0.85rem',
                color: '#94a3b8',
                margin: '0 0 0.5rem 0',
                paddingLeft: '1.25rem',
                fontWeight: '500',
              }}
            >
              {t('home.hero.micro_hint')}
            </p>
            <button className="hero-secondary-button" onClick={handleFaceAnalysisClick}>{t('home.hero.secondary_cta')}</button>
            <p className="hero-secondary-hint">{t('home.hero.secondary_hint')}</p>
          </div>

          <div className="hero-reviews-marquee-wrapper">
            <div className="hero-reviews-marquee">
              {[...REVIEWS, ...REVIEWS].map((review, i) => (
                <div key={i} className="hero-review-card">
                  <div className="hero-review-header">
                    <span className="hero-review-name">{review.name}</span>
                    <span className="hero-review-stars">
                      {'★'.repeat(Math.floor(review.score))}
                      {review.score % 1 > 0 ? '☆' : ''}
                    </span>
                  </div>
                  <p className="hero-review-text">"{review.text}"</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="hero-visual-content">
          <HeroPreviewCard />
          <HeroVisual />
        </div>
      </div>
    </section>
  );
}
